import MapPageEmergency from './MapPageEmergency';

export default MapPageEmergency;
